import { useScrollReveal } from '@/hooks/useScrollReveal';

const FounderSection = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="founder-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-wide">
        <div className="flex flex-col-reverse md:flex-row gap-10 md:gap-16 items-center">
          <div className="flex-1">
            <p className="body-text" data-testid="founder-bio-1">
              I&rsquo;m Vino. Co-founder and CEO of Bottega Studios, a deep-tech company in real-time rendering and compression of volumetric and light-field content, whose technology assets were acquired by Snap Inc. in 2022. I&rsquo;ve been through the fundraising, the cofounder dynamics, the strategic pivots that look obvious in hindsight but felt impossible in the moment.
            </p>
            <p className="body-text mt-6" data-testid="founder-bio-2">
              Now I work with founders who are already in motion but stuck in complexity they can&rsquo;t see from inside. I don&rsquo;t add frameworks or tactics. I strip away what doesn&rsquo;t matter until the path is obvious.
            </p>
            <p className="body-text mt-6" data-testid="founder-bio-3">
              Mostly async. Always direct. If something is broken, I&rsquo;ll tell you.
            </p>
          </div>

          <div className="flex-shrink-0">
            <div className="founder-photo-wrapper" data-testid="founder-photo">
              <picture>
                <source srcSet="/founder-opt.webp" type="image/webp" />
                <img
                  src="/founder-opt.png"
                  alt="Vino — Founder, Soundboard.space"
                  className="founder-photo"
                  loading="lazy"
                  width="300"
                  height="300"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
